module.exports = __webpack_public_path__ + "static/media/fa-brands-400.c2ec6f2c.ttf";